import firebase from '../../firebase/compat'
import callWithColdStartRetry from './callWithColdStartRetry'
import whenAuthKnown from '../auth/whenAuthKnown'

/**
 * Het detail van één cel, via de super-admin-callable. Zelfde recept als
 * fetchThemeInterviews: eerst de inlog afwachten, dan één herkansing bij een
 * koude start.
 *
 * @param {string} cellId
 * @param {{delayMs?: number}} [opties]
 * @returns {Promise<{found: boolean, cell: (object|null), orgEffects: (Array<object>|null), mechanisms: (Array<object>|null), interviews: Array<object>}>}
 */
export const fetchCellDetail = async (cellId, opties = {}) => {
    await whenAuthKnown()
    const callable = firebase.app().functions('europe-west1').httpsCallable('getCellDetail')
    const result = await callWithColdStartRetry(callable, { cellId }, opties)
    return result.data
}

export default fetchCellDetail
